import React from 'react';
import { ResizableTable } from '../../utils';
import { permissionManagerColumns } from '../Templates/columns';
import { Y_SCROLL } from './styles';
import { SearchOutlined } from '@ant-design/icons';

const LeftPanel = React.memo(({ tableData, permissionWidths, selectedUser, handleSelectedUser, handleWidthChange }) => (
  <ResizableTable
    dataSource={tableData.map((t) => ({ ...t, key: t['email-id'] }))}
    inputColumns={permissionManagerColumns(tableData, permissionWidths)}
    rowSelection={{
      type: 'radio',
      selectedRowKeys: [selectedUser],
      onChange: handleSelectedUser,
    }}
    scroll={Y_SCROLL}
    widthHandler={handleWidthChange}
    searchableProps={{
      inputProps: {
        placeholder: 'Search in table...',
        prefix: <SearchOutlined />,
      },
      searchFunction(dataSource, searchTerm) {
        return (dataSource ?? [])
          .filter((row) => row && typeof row === 'object')
          .filter((row) => {
            return Object.values(row).some((val) => {
              const performSearch = (searchVal) => {
                if (searchVal === undefined || searchVal === null) return false;
                return searchVal.toString().toLowerCase().includes(searchTerm.toLowerCase());
              };
              if (Array.isArray(val)) {
                return val.some(performSearch);
              }
              return performSearch(val);
            });
          });
      },
    }}
  />
));

export default LeftPanel;
